<template>
<div id="app" class="app">
    <router-view />
</div>
</template>

<script>
export default {
    created() {
        // 注入 iview 通知
        Utils.Notice = this.$Notice;
    },
};
</script>

<style lang="scss">
body, html, #app {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    // 不允许选择文字
    -moz-user-select:none;
    -webkit-user-select:none;
    user-select:none;
}
</style>
